import React, { useState, useEffect, useRef } from 'react';
import { Edit2, Check, X, Package, AlertCircle, Truck, Send, CheckCircle, Loader, ChevronDown, Printer } from 'lucide-react';
import host from '../../assets/js/Host';

const OrdersManagementPage = () => {
  // قائمة المحافظات والمناطق الثابتة (fallback)
  const staticGovernoratesData = {

  };

  const [governoratesData, setGovernoratesData] = useState(staticGovernoratesData);
  const [areasFromAPI, setAreasFromAPI] = useState([]);
  const [govIdMap, setGovIdMap] = useState({});
  const [areasLoading, setAreasLoading] = useState(false);
  const [readyOrders, setReadyOrders] = useState([]);
  const [errorOrders, setErrorOrders] = useState([]);
  const [sentOrders, setSentOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [editingCell, setEditingCell] = useState({ orderId: null, field: null, table: null });
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);
  const [sendingOrders, setSendingOrders] = useState(false); // حالة السبنر

  const [additionalInfo, setAdditionalInfo] = useState({
    cash: 0,
    totalPrice: 0,
    cashOrders: 0,
    name: '',
    printId: ''
  });

  // جلب البيانات من API
  useEffect(() => {
    const loadData = async () => {
      console.log('بدء تحميل البيانات...');
      await fetchAreas();
      console.log('تم تحميل المناطق');
      setTimeout(async () => {
        console.log('بدء تحميل الطلبات...');
        await fetchOrders();
        console.log('تم تحميل الطلبات');
      }, 500);
    };
    loadData();
  }, []);

  // جلب المناطق من API
  const fetchAreas = async () => {
    try {
      setAreasLoading(true);
      const response = await fetch(`${host}users/get_areas`);
      const result = await response.json();

      console.log('الاستجابة الكاملة من API:', result);

      let areas = [];

      if (Array.isArray(result)) {
        areas = result;
      } else if (result.data && Array.isArray(result.data)) {
        areas = result.data;
      } else if (result.areas && Array.isArray(result.areas)) {
        areas = result.areas;
      } else if (result.result && Array.isArray(result.result)) {
        areas = result.result;
      } else {
        console.error('بنية غير متوقعة للبيانات:', result);
      }

      console.log('المناطق المستخرجة:', areas.length, 'منطقة');

      if (Array.isArray(areas) && areas.length > 0) {
        setAreasFromAPI(areas);

        console.log('بنية أول منطقة:', areas[0]);
        console.log('الحقول المتاحة:', Object.keys(areas[0] || {}));

        const organizedData = {};

        Object.keys(staticGovernoratesData).forEach(gov => {
          organizedData[gov] = [...staticGovernoratesData[gov]];
        });

        const govNameToIdMap = {};

        areas.forEach(area => {
          const govName = area.gov_name ? area.gov_name.trim() :
            area.gov_id ? area.gov_id.trim() : '';
          const govId = area.gov_id ? area.gov_id.trim() : '';
          const cityName = area.city_name ? area.city_name.trim() : '';

          if (govId && area.gov_name) {
            govNameToIdMap[area.gov_name.trim()] = govId;
          }

          if (cityName === '') {
            return;
          }

          let matchedGovName = govName;
          Object.keys(organizedData).forEach(existingGov => {
            if (existingGov.trim() === govName ||
              existingGov.replace(/\s/g, '') === govName.replace(/\s/g, '')) {
              matchedGovName = existingGov;
            }
          });

          if (!organizedData[matchedGovName]) {
            organizedData[matchedGovName] = [];
          }

          if (!organizedData[matchedGovName].includes(cityName)) {
            organizedData[matchedGovName].push(cityName);
          }
        });

        Object.keys(organizedData).forEach(gov => {
          organizedData[gov] = organizedData[gov].sort();
        });

        setGovernoratesData(organizedData);
        setGovIdMap(govNameToIdMap);
        console.log('خريطة gov_name إلى gov_id:', govNameToIdMap);
        console.log('البيانات المنظمة النهائية:', organizedData);
      } else {
        console.log('لا توجد مناطق في الاستجابة، استخدام البيانات الثابتة');
        setGovernoratesData(staticGovernoratesData);
      }
    } catch (err) {
      console.error('Error fetching areas:', err);
      setGovernoratesData(staticGovernoratesData);
    } finally {
      setAreasLoading(false);
    }
  };

  const fetchOrders = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    let Getid = urlParams.get('id')

    try {
      setLoading(true);
      const response = await fetch(`${host}users/printed/orders/edit/${Getid}`);
      const result = await response.json();

      console.log('البيانات المستلمة من API:', result);

      if (result.statusCode === 200 && result.data) {
        const { orders, cash, total_price, cash_orders, name, print_id } = result.data;

        console.log('عينة من الطلبات:', orders.slice(0, 3));
        console.log('المحافظات المتاحة في governoratesData:', Object.keys(governoratesData));

        const ready = [];
        const errors = [];
        const sent = [];

        orders.forEach(order => {
          console.log(`معالجة طلب ${order.id}: govName="${order.govName}", corrected="${order.corrected}"`);

          const governmentExists = Object.keys(governoratesData).some(
            gov => gov === order.govName || gov === order.govName?.trim()
          );

          const correctGovernment = governmentExists ? order.govName :
            Object.keys(governoratesData).find(gov =>
              gov.trim() === order.govName?.trim()
            ) || order.govName || '';

          const formattedOrder = {
            id: order.id,
            receiptNumber: order.id.toString(),
            recipientName: order.name,
            recipientPhone: order.phone,
            governorate: correctGovernment,
            area: order.corrected || '',
            nearestPoint: order.city || '',
            item: order.notes2 || '',
            price: order.price || 0,
            notes: order.notes || '',
            refId: order.ref_id || '',
            hasAreaError: !order.corrected || order.corrected === '' || order.corrected === 'أخرى',
            remark: order.remark || order.error || 'مشكلة في البيانات',
            itemsCount: order.items_count !== undefined && order.items_count !== null ? order.items_count : 1,
            replacement: order.replacement !== undefined && order.replacement !== null ? order.replacement : 1,
            originalGovName: order.govName
          };

          if (order.checked === 0 || order.checked === false) {
            ready.push(formattedOrder);
          } else if (order.checked === 1) {
            errors.push(formattedOrder);
          } else if (order.checked === 2 || order.checked === true) {
            sent.push(formattedOrder);
          }
        });

        console.log(`تم معالجة: ${ready.length} جاهز، ${errors.length} أخطاء، ${sent.length} مرسل`);

        setReadyOrders(ready);
        setErrorOrders(errors);
        setSentOrders(sent);
        setAdditionalInfo({
          cash: cash || 0,
          totalPrice: total_price || 0,
          cashOrders: cash_orders || 0,
          name: name || '',
          printId: print_id || ''
        });
      }
    } catch (err) {
      setError('فشل في جلب البيانات');
      console.error('Error fetching orders:', err);
    } finally {
      setLoading(false);
    }
  };

  // دالة لتنسيق رقم الهاتف للإرسال
  const formatPhoneForSending = (phone) => {
    if (!phone) return phone;

    let cleanPhone = phone.toString().replace(/[\s-+]/g, '');

    if (cleanPhone.startsWith('0')) {
      cleanPhone = cleanPhone.substring(1);
    }

    if (!cleanPhone.startsWith('964')) {
      cleanPhone = '+964' + cleanPhone;
    } else {
      cleanPhone = '+' + cleanPhone;
    }

    return cleanPhone;
  };

  // دالة للحصول على gov_id من اسم المحافظة
  const getGovId = (govName) => {
    if (!govName) return null;

    if (govIdMap[govName]) {
      return govIdMap[govName];
    }

    const cleanGovName = govName.trim();
    if (govIdMap[cleanGovName]) {
      return govIdMap[cleanGovName];
    }

    const matchingArea = areasFromAPI.find(area =>
      area.gov_name && area.gov_name.trim() === cleanGovName
    );

    return matchingArea ? matchingArea.gov_id : null;
  };

  // دالة للحصول على area_id من اسم المنطقة والمحافظة
  const getAreaId = (areaName, govName) => {
    if (!areaName || !govName) return null;

    const cleanAreaName = areaName.trim();
    const cleanGovName = govName.trim();

    const matchingArea = areasFromAPI.find(area =>
      area.city_name && area.city_name.trim() === cleanAreaName &&
      area.gov_name && area.gov_name.trim() === cleanGovName
    );

    if (matchingArea) {
      return matchingArea.area_id || matchingArea.id || matchingArea.city_id || null;
    }

    return null;
  };

  // إغلاق القائمة المنسدلة عند النقر خارجها
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // تحديث الطلب
  const updateOrder = (orderId, field, value, table) => {
    let updateFunction;
    let orders;

    if (table === 'ready') {
      updateFunction = setReadyOrders;
      orders = readyOrders;
    } else if (table === 'error') {
      updateFunction = setErrorOrders;
      orders = errorOrders;
    } else {
      return;
    }

    updateFunction(orders.map(order => {
      if (order.id === orderId) {
        if (field === 'governorate') {
          const newAreas = governoratesData[value] || [];
          return {
            ...order,
            governorate: value,
            area: newAreas.includes(order.area) ? order.area : newAreas[0] || '',
            hasAreaError: false
          };
        }
        if (field === 'area') {
          return {
            ...order,
            area: value,
            hasAreaError: !value || value === '' || value === 'أخرى'
          };
        }
        return { ...order, [field]: value };
      }
      return order;
    }));

    setEditingCell({ orderId: null, field: null, table: null });
    setShowDropdown(false);
  };

  // بدء التحرير
  const startEditing = (orderId, field, currentValue, table) => {
    setEditingCell({ orderId, field, table });
    setSearchTerm(currentValue || '');

    setTimeout(() => {
      const activeCell = document.querySelector(`[data-cell-id="${orderId}-${field}"]`);
      if (activeCell) {
        const rect = activeCell.getBoundingClientRect();
        const dropdownHeight = 300;
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;

        let top, left;

        if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
          top = rect.top - dropdownHeight;
        } else {
          top = rect.bottom + 4;
        }

        top = Math.min(top, window.innerHeight - dropdownHeight - 20);
        top = Math.max(top, 20);

        left = Math.min(rect.left, window.innerWidth - 300);
        left = Math.max(left, 20);

        setDropdownPosition({ top, left });
      }
    }, 0);

    if (field === 'governorate') {
      const options = Object.keys(governoratesData).sort();
      setFilteredOptions(options);
      setShowDropdown(true);
    } else if (field === 'area') {
      let orders;
      if (table === 'ready') {
        orders = readyOrders;
      } else if (table === 'error') {
        orders = errorOrders;
      } else {
        return;
      }

      const order = orders.find(o => o.id === orderId);
      if (order && order.governorate) {
        const governorateKey = order.governorate.trim();

        console.log('\n=== تحرير المنطقة ===');
        console.log('المحافظة للطلب:', governorateKey);

        let allAreas = new Set();

        const organizedAreas = governoratesData[governorateKey] || [];
        organizedAreas.forEach(area => {
          if (area && area.trim() !== '') {
            allAreas.add(area.trim());
          }
        });

        if (staticGovernoratesData[governorateKey]) {
          staticGovernoratesData[governorateKey].forEach(area => {
            if (area && area.trim() !== '') {
              allAreas.add(area.trim());
            }
          });
        }

        if (areasFromAPI.length > 0) {
          areasFromAPI
            .filter(area => {
              const areaGovName = area.gov_name ? area.gov_name.trim() :
                area.gov_id ? area.gov_id.trim() : '';
              return areaGovName === governorateKey.trim() &&
                area.city_name && area.city_name.trim() !== '';
            })
            .forEach(area => {
              allAreas.add(area.city_name.trim());
            });
        }

        const uniqueAreas = Array.from(allAreas).sort();

        console.log('جميع المناطق المجمعة:', uniqueAreas);
        console.log('عدد المناطق:', uniqueAreas.length);

        setFilteredOptions(uniqueAreas);
      } else {
        setFilteredOptions([]);
      }
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  // تصفية الخيارات
  const handleSearch = (value) => {
    setSearchTerm(value);
    let options = [];

    if (editingCell.field === 'governorate') {
      options = Object.keys(governoratesData).sort();
    } else if (editingCell.field === 'area') {
      let orders;
      if (editingCell.table === 'ready') {
        orders = readyOrders;
      } else if (editingCell.table === 'error') {
        orders = errorOrders;
      } else {
        return;
      }

      const order = orders.find(o => o.id === editingCell.orderId);
      if (order && order.governorate) {
        const governorateKey = order.governorate.trim();

        let allAreas = new Set();

        const organizedAreas = governoratesData[governorateKey] || [];
        organizedAreas.forEach(area => {
          if (area && area.trim() !== '') {
            allAreas.add(area.trim());
          }
        });

        if (staticGovernoratesData[governorateKey]) {
          staticGovernoratesData[governorateKey].forEach(area => {
            if (area && area.trim() !== '') {
              allAreas.add(area.trim());
            }
          });
        }

        if (areasFromAPI.length > 0) {
          areasFromAPI
            .filter(area => {
              const areaGovName = area.gov_name ? area.gov_name.trim() :
                area.gov_id ? area.gov_id.trim() : '';
              return areaGovName === governorateKey.trim() &&
                area.city_name && area.city_name.trim() !== '';
            })
            .forEach(area => {
              allAreas.add(area.city_name.trim());
            });
        }

        options = Array.from(allAreas).sort();
      }
    }

    if (value.trim() === '') {
      setFilteredOptions(options);
    } else {
      const filtered = options.filter(option =>
        option.toLowerCase().includes(value.toLowerCase()) ||
        option.replace(/\s/g, '').toLowerCase().includes(value.replace(/\s/g, '').toLowerCase())
      );
      setFilteredOptions(filtered);
    }

    setShowDropdown(true);
  };

  // إلغاء التحرير
  const cancelEditing = () => {
    setEditingCell({ orderId: null, field: null, table: null });
    setShowDropdown(false);
    setSearchTerm('');
  };

  // دالة عامة لإرسال الطلبات
  const sendOrders = async (ordersToSend, sourceTable) => {
    if (window.confirm(`هل أنت متأكد من إرسال ${ordersToSend.length} طلب؟`)) {
      try {
        setSendingOrders(true); // بدء السبنر

        // التحقق من صحة المناطق قبل الإرسال
        let hasInvalidArea = false;
        for (const order of ordersToSend) {
          const areaId = getAreaId(order.area, order.governorate);
          if (!areaId || order.area === 'أخرى') {
            window.alert(`الطلب ${order.id} يحتوي على منطقة غير صحيحة. الرجاء تصحيحها قبل الإرسال.`);
            hasInvalidArea = true;
            setSendingOrders(false);
            break;
          }
        }

        if (hasInvalidArea) {
          return;
        }

        const formattedOrders = ordersToSend.map(order => {
          const govId = getGovId(order.governorate);
          const areaId = getAreaId(order.area, order.governorate);
          const itemsCount = order.itemsCount !== undefined && order.itemsCount !== null ? order.itemsCount : 1;
          const replacement = order.replacement !== undefined && order.replacement !== null ? order.replacement : 1;
          const formattedPhone = formatPhoneForSending(order.recipientPhone);

          console.log(`تنسيق رقم الهاتف للطلب ${order.id}: من ${order.recipientPhone} إلى ${formattedPhone}`);
          console.log(`قيمة replacement للطلب ${order.id}: ${replacement}`);
          console.log(`قيمة corrected (المنطقة) للطلب ${order.id}: ${order.area}`);
          console.log(`قيمة city (أقرب نقطة) للطلب ${order.id}: ${order.nearestPoint}`);

          return {
            client_name: order.recipientName || '/',
            client_mobile: formattedPhone,
            client_mobile2: '',
            city_id: govId,
            region_id: areaId,
            location: order.nearestPoint || '',
            type_name: order.item || '',
            items_number: itemsCount || 1,
            price: parseInt(order.price) * 1000,
            package_size: 1,
            merchant_notes: order.notes || '',
            replacement: replacement,
            merchant_id: 1380,
            company_order_id: order.id,
            corrected: order.area || '',
            city: order.nearestPoint || '',
            metadata: ''
          };
        });

        console.log('الطلبات المنسقة للإرسال:', formattedOrders);

        const response = await fetch(`${host}users/send_orders`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            orders: formattedOrders
          })
        });

        const result = await response.json();
        console.log('نتيجة الإرسال:', result);

        if (response.ok && result.statusCode === 200) {
          setShowSuccessMessage(true);

          // تحديث الطلبات المرسلة
          const updatedSentOrders = ordersToSend.map(order => ({
            ...order,
            refId: result.data?.refIds?.[order.id] || ''
          }));

          setSentOrders([...sentOrders, ...updatedSentOrders]);

          // إزالة الطلبات المرسلة من القائمة المصدر
          if (sourceTable === 'ready') {
            setReadyOrders(readyOrders.filter(order =>
              !ordersToSend.find(sent => sent.id === order.id)
            ));
          } else if (sourceTable === 'error') {
            setErrorOrders(errorOrders.filter(order =>
              !ordersToSend.find(sent => sent.id === order.id)
            ));
          }

          // إعادة تحميل البيانات بعد الإرسال الناجح
          setTimeout(async () => {
            setShowSuccessMessage(false);
            setSendingOrders(false);
            await fetchOrders(); // تحديث البيانات من السيرفر
          }, 5000);
          window.location.reload();
        } else {
          alert(`فشل إرسال الطلبات: ${result.message || 'خطأ غير معروف'}`);
        window.location.reload();
          console.error('خطأ في الإرسال:', result);
          setSendingOrders(false);
        }

      } catch (error) {
        console.error('خطأ في إرسال الطلبات:', error);
        alert('حدث خطأ أثناء إرسال الطلبات');
        setSendingOrders(false);
      }
    }
  };

  // إرسال الطلبات الجاهزة (30 طلب فقط)
  const sendAllReadyOrders = async () => {
    const ordersToSend = readyOrders.slice(0, 30);
    await sendOrders(ordersToSend, 'ready');
  };

  // إرسال الطلبات التي بها أخطاء (30 طلب فقط)
  const sendAllErrorOrders = async () => {
    const ordersToSend = errorOrders.slice(0, 30);
    await sendOrders(ordersToSend, 'error');
  };

  // حساب الإحصائيات
  const totalOrders = readyOrders.length + sentOrders.length + errorOrders.length;

  // عرض أول 30 طلب فقط
  const displayedReadyOrders = readyOrders.slice(0, 30);
  const displayedErrorOrders = errorOrders.slice(0, 30);
  const displayedSentOrders = sentOrders.slice(0, 30);

  // Styles
  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#f5f7fa',
      direction: 'rtl',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
    },
    header: {
      backgroundColor: 'white',
      borderBottom: '1px solid #e1e8ed',
      padding: '24px 0',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
      marginBottom: '32px'
    },
    headerContent: {
      maxWidth: '100%',
      margin: '0 auto',
      padding: '0 16px'
    },
    title: {
      fontSize: '32px',
      fontWeight: '700',
      color: '#2c3e50',
      margin: 0
    },
    subtitle: {
      fontSize: '16px',
      color: '#7f8c8d',
      marginTop: '8px',
      margin: 0
    },
    mainContent: {
      maxWidth: '100%',
      margin: '0 auto',
      padding: '0 16px 48px'
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '20px',
      marginBottom: '40px'
    },
    statCard: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '24px',
      border: '1px solid #e1e8ed',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      transition: 'transform 0.2s, box-shadow 0.2s',
      cursor: 'default'
    },
    statIcon: {
      width: '48px',
      height: '48px',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    },
    statInfo: {
      flex: 1
    },
    statLabel: {
      fontSize: '14px',
      color: '#7f8c8d',
      marginBottom: '4px',
      fontWeight: '500'
    },
    statValue: {
      fontSize: '28px',
      fontWeight: '700',
      color: '#2c3e50'
    },
    section: {
      backgroundColor: 'white',
      borderRadius: '16px',
      border: '1px solid #e1e8ed',
      marginBottom: '32px',
      overflow: 'hidden'
    },
    sectionHeader: {
      padding: '20px 24px',
      borderBottom: '2px solid #e1e8ed',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#f8f9fb'
    },
    sectionTitle: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      fontSize: '18px',
      fontWeight: '600',
      color: '#2c3e50'
    },
    badge: {
      fontSize: '14px',
      padding: '4px 10px',
      borderRadius: '6px',
      fontWeight: '500'
    },
    sendButton: {
      backgroundColor: '#27ae60',
      color: 'white',
      padding: '10px 20px',
      borderRadius: '8px',
      border: 'none',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      transition: 'background-color 0.2s'
    },
    table: {
      width: '100%',
      borderCollapse: 'separate',
      borderSpacing: '0'
    },
    th: {
      padding: '18px 24px',
      backgroundColor: '#f8f9fb',
      borderBottom: '2px solid #e1e8ed',
      borderRight: '1px solid #e1e8ed',
      textAlign: 'right',
      fontSize: '17px',
      fontWeight: '700',
      color: '#5a6c7d',
      textTransform: 'none',
      letterSpacing: '0'
    },
    td: {
      padding: '18px 24px',
      borderBottom: '1px solid #eef2f5',
      borderRight: '1px solid #eef2f5',
      fontSize: '18px',
      fontWeight: '600',
      color: '#2c3e50',
      backgroundColor: 'white'
    },
    editableCell: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      minHeight: '32px'
    },
    editButton: {
      padding: '4px',
      color: '#5a6c7d',
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      opacity: 0,
      transition: 'opacity 0.2s, background-color 0.2s'
    },
    warningCell: {
      backgroundColor: '#fff3cd',
      borderColor: '#ffeaa7',
      padding: '18px 24px',
      borderBottom: '2px solid #ffeaa7',
      borderRight: '2px solid #ffeaa7',
      fontSize: '18px',
      fontWeight: '600',
      position: 'relative'
    },
    warningText: {
      color: '#856404',
      fontWeight: '700',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '18px'
    },
    errorText: {
      color: '#e74c3c',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      fontWeight: '700',
      fontSize: '18px'
    },
    input: {
      width: '100%',
      padding: '8px 12px',
      border: '2px solid #3498db',
      borderRadius: '6px',
      fontSize: '14px',
      outline: 'none',
      backgroundColor: 'white'
    },
    dropdown: {
      position: 'fixed',
      backgroundColor: 'white',
      border: '1px solid #e1e8ed',
      borderRadius: '8px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
      maxHeight: '300px',
      overflowY: 'auto',
      zIndex: 9999,
      minWidth: '250px'
    },
    dropdownHeader: {
      padding: '12px 16px',
      borderBottom: '1px solid #e1e8ed',
      backgroundColor: '#f8f9fb',
      fontSize: '13px',
      fontWeight: '600',
      color: '#5a6c7d',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'sticky',
      top: 0
    },
    dropdownOption: {
      padding: '12px 16px',
      cursor: 'pointer',
      fontSize: '14px',
      color: '#2c3e50',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      borderBottom: '1px solid #f5f7fa',
      transition: 'background-color 0.15s'
    },
    dropdownEmpty: {
      padding: '24px',
      textAlign: 'center',
      color: '#95a5a6',
      fontSize: '14px'
    },
    dropdownAddNew: {
      padding: '12px 16px',
      backgroundColor: '#e8f5e9',
      color: '#27ae60',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      borderTop: '1px solid #e1e8ed'
    },
    inputWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      position: 'relative',
      width: '100%'
    },
    actionButton: {
      padding: '6px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background-color 0.2s'
    },
    successMessage: {
      position: 'fixed',
      top: '24px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#27ae60',
      color: 'white',
      padding: '16px 24px',
      borderRadius: '8px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      zIndex: 1000,
      fontWeight: '500'
    },
    emptyState: {
      padding: '48px',
      textAlign: 'center',
      color: '#95a5a6'
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '400px',
      flexDirection: 'column',
      gap: '16px'
    },
    scrollWrapper: {
      overflowX: 'auto',
      overflowY: 'visible'
    },
    sendingOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10000
    },
    sendingBox: {
      backgroundColor: 'white',
      borderRadius: '16px',
      padding: '48px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
    },
    sendingText: {
      fontSize: '20px',
      color: '#2c3e50',
      fontWeight: '600'
    }
  };

  // عرض حقل التحرير
  const renderEditableField = (order, field, value, table) => {
    const isEditing = editingCell.orderId === order.id && editingCell.field === field && editingCell.table === table;
    const isAreaError = field === 'area' && order.hasAreaError;

    if (table === 'sent') {
      return (
        <span style={isAreaError ? styles.errorText : {}}>
          {value || '-'}
          {isAreaError && <AlertCircle size={14} />}
        </span>
      );
    }

    if (table === 'ready' && field === 'notes') {
      return <span>{value || '-'}</span>;
    }

    if (isEditing && (field === 'governorate' || field === 'area')) {
      return (
        <div data-cell-id={`${order.id}-${field}`} style={{ position: 'relative', width: '100%' }}>
          <div style={styles.inputWrapper}>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Escape') cancelEditing();
                else if (e.key === 'Enter' && searchTerm) updateOrder(order.id, field, searchTerm, table);
              }}
              style={styles.input}
              placeholder={field === 'governorate' ? 'ابحث عن محافظة...' : 'ابحث عن منطقة...'}
              autoFocus
            />
            <button
              onClick={() => updateOrder(order.id, field, searchTerm, table)}
              style={{ ...styles.actionButton, backgroundColor: '#e8f5e9', color: '#27ae60' }}
              onMouseEnter={e => e.target.style.backgroundColor = '#c8e6c9'}
              onMouseLeave={e => e.target.style.backgroundColor = '#e8f5e9'}
            >
              <Check size={18} />
            </button>
            <button
              onClick={cancelEditing}
              style={{ ...styles.actionButton, backgroundColor: '#ffebee', color: '#e74c3c' }}
              onMouseEnter={e => e.target.style.backgroundColor = '#ffcdd2'}
              onMouseLeave={e => e.target.style.backgroundColor = '#ffebee'}
            >
              <X size={18} />
            </button>
          </div>

          {showDropdown && (
            <div ref={dropdownRef} style={{
              ...styles.dropdown,
              top: `${dropdownPosition.top}px`,
              left: `${dropdownPosition.left}px`,
              width: '280px'
            }}>
              {field === 'area' && filteredOptions.length > 0 && (
                <div style={styles.dropdownHeader}>
                  <span>مناطق {order.governorate}</span>
                  <span style={{ ...styles.badge, backgroundColor: '#e0e7ff', color: '#4f46e5' }}>
                    {filteredOptions.length}
                  </span>
                </div>
              )}

              {filteredOptions.length > 0 ? (
                filteredOptions.map((option, index) => (
                  <div
                    key={`${option}-${index}`}
                    onClick={() => updateOrder(order.id, field, option, table)}
                    style={styles.dropdownOption}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f8fafc'}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                  >
                    <span style={{
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      backgroundColor: option === value ? '#3498db' : '#bdc3c7'
                    }} />
                    <span style={{ fontWeight: option === value ? '600' : '400' }}>{option}</span>
                  </div>
                ))
              ) : (
                <div style={styles.dropdownEmpty}>
                  <AlertCircle size={20} style={{ marginBottom: '8px', color: '#cbd5e1' }} />
                  <div>{field === 'area' ? 'لا توجد مناطق متاحة' : 'لا توجد نتائج'}</div>
                </div>
              )}

              {searchTerm && !filteredOptions.includes(searchTerm) && (
                <div
                  onClick={() => updateOrder(order.id, field, searchTerm, table)}
                  style={styles.dropdownAddNew}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = '#c8e6c9'}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = '#e8f5e9'}
                >
                  <Check size={16} />
                  إضافة "{searchTerm}"
                </div>
              )}
            </div>
          )}
        </div>
      );
    }

    if (isEditing) {
      return (
        <div style={styles.inputWrapper}>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Escape') cancelEditing();
              else if (e.key === 'Enter') updateOrder(order.id, field, searchTerm, table);
            }}
            style={styles.input}
            autoFocus
          />
          <button
            onClick={() => updateOrder(order.id, field, searchTerm, table)}
            style={{ ...styles.actionButton, backgroundColor: '#f0fdf4', color: '#10b981' }}
          >
            <Check size={18} />
          </button>
          <button
            onClick={cancelEditing}
            style={{ ...styles.actionButton, backgroundColor: '#fef2f2', color: '#ef4444' }}
          >
            <X size={18} />
          </button>
        </div>
      );
    }

    return (
      <div
        style={styles.editableCell}
        onMouseEnter={e => {
          const button = e.currentTarget.querySelector('button');
          if (button) button.style.opacity = 1;
        }}
        onMouseLeave={e => {
          const button = e.currentTarget.querySelector('button');
          if (button) button.style.opacity = 0;
        }}
      >
        <span style={isAreaError || (field === 'remark') ? styles.errorText : {}}>
          {value || '-'}
          {isAreaError && <AlertCircle size={14} />}
        </span>
        <button
          onClick={() => startEditing(order.id, field, value, table)}
          style={styles.editButton}
          onMouseEnter={e => e.target.style.backgroundColor = '#e0e7ff'}
          onMouseLeave={e => e.target.style.backgroundColor = 'transparent'}
        >
          <Edit2 size={14} />
        </button>
      </div>
    );
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loadingContainer}>
          <Loader size={48} style={{ animation: 'spin 1s linear infinite', color: '#3498db' }} />
          <span style={{ fontSize: '16px', color: '#7f8c8d' }}>جاري تحميل البيانات...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.container}>
        <div style={styles.mainContent}>
          <div style={{ ...styles.section, padding: '48px', textAlign: 'center' }}>
            <AlertCircle size={48} style={{ color: '#e74c3c', marginBottom: '16px' }} />
            <h2 style={{ fontSize: '24px', color: '#2c3e50', marginBottom: '16px' }}>{error}</h2>
            <button
              onClick={fetchOrders}
              style={{ ...styles.sendButton, backgroundColor: '#3498db', margin: '0 auto' }}
            >
              إعادة المحاولة
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Overlay للسبنر عند إرسال الطلبات */}
      {sendingOrders && (
        <div style={styles.sendingOverlay}>
          <div style={styles.sendingBox}>
            <Loader size={64} style={{ animation: 'spin 1s linear infinite', color: '#3498db' }} />
            <span style={styles.sendingText}>جاري إرسال الطلبات...</span>
            <span style={{ fontSize: '16px', color: '#7f8c8d' }}>يرجى الانتظار</span>
          </div>
        </div>
      )}

      {showSuccessMessage && (
        <div style={styles.successMessage}>
          <CheckCircle size={24} />
          <span>تم إرسال الطلبات بنجاح!</span>
        </div>
      )}

      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h1 style={styles.title}>نظام إدارة الطلبات</h1>
              {additionalInfo.name && (
                <p style={styles.subtitle}>
                  {additionalInfo.name} • رقم الطباعة: {additionalInfo.printId}
                </p>
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{
                padding: '8px 16px',
                backgroundColor: '#f0f4f8',
                borderRadius: '8px',
                fontWeight: '600',
                color: '#5a6c7d'
              }}>
                {sentOrders.length} / {totalOrders}
              </div>
              <button
                onClick={() => {
                  const urlParams = new URLSearchParams(window.location.search);
                  let Getid = urlParams.get('id')
                  if (sentOrders.length === totalOrders) {
                    window.location.href = `/printLabel?id=${Getid}`
                  }
                }}
                disabled={sentOrders.length !== totalOrders}
                style={{
                  ...styles.sendButton,
                  backgroundColor: sentOrders.length === totalOrders ? '#10b981' : '#cbd5e1',
                  cursor: sentOrders.length === totalOrders ? 'pointer' : 'not-allowed',
                  opacity: sentOrders.length === totalOrders ? 1 : 0.6,
                  minWidth: '180px'
                }}
                onMouseEnter={e => {
                  if (sentOrders.length === totalOrders) {
                    e.target.style.backgroundColor = '#059669';
                  }
                }}
                onMouseLeave={e => {
                  if (sentOrders.length === totalOrders) {
                    e.target.style.backgroundColor = '#10b981';
                  }
                }}
              >
                <Printer size={18} />
                جاهز للطباعة
              </button>
            </div>
          </div>
        </div>
      </header>

      <div style={styles.mainContent}>
        <div style={styles.statsGrid}>
          <div
            style={styles.statCard}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div style={{ ...styles.statIcon, backgroundColor: '#e3f2fd' }}>
              <Package size={24} color="#2196f3" />
            </div>
            <div style={styles.statInfo}>
              <div style={styles.statLabel}>إجمالي الطلبات</div>
              <div style={styles.statValue}>{totalOrders}</div>
            </div>
          </div>

          <div
            style={styles.statCard}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div style={{ ...styles.statIcon, backgroundColor: '#e8f5e9' }}>
              <Truck size={24} color="#27ae60" />
            </div>
            <div style={styles.statInfo}>
              <div style={styles.statLabel}>جاهزة للإرسال</div>
              <div style={styles.statValue}>{readyOrders.length}</div>
            </div>
          </div>

          <div
            style={styles.statCard}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div style={{ ...styles.statIcon, backgroundColor: '#e8eaf6' }}>
              <CheckCircle size={24} color="#5c6bc0" />
            </div>
            <div style={styles.statInfo}>
              <div style={styles.statLabel}>تم الإرسال</div>
              <div style={styles.statValue}>{sentOrders.length}</div>
            </div>
          </div>

          <div
            style={styles.statCard}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div style={{ ...styles.statIcon, backgroundColor: '#ffebee' }}>
              <AlertCircle size={24} color="#e57373" />
            </div>
            <div style={styles.statInfo}>
              <div style={styles.statLabel}>بها أخطاء</div>
              <div style={styles.statValue}>{errorOrders.length}</div>
            </div>
          </div>

          <div
            style={styles.statCard}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div style={{ ...styles.statIcon, backgroundColor: '#fff3e0' }}>
              <span style={{ fontSize: '24px' }}>💰</span>
            </div>
            <div style={styles.statInfo}>
              <div style={styles.statLabel}>المبلغ النقدي</div>
              <div style={styles.statValue}>{additionalInfo.cash.toLocaleString()} د.ع</div>
            </div>
          </div>

          <div
            style={styles.statCard}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div style={{ ...styles.statIcon, backgroundColor: '#f3e5f5' }}>
              <span style={{ fontSize: '24px' }}>💳</span>
            </div>
            <div style={styles.statInfo}>
              <div style={styles.statLabel}>إجمالي السعر</div>
              <div style={styles.statValue}>{additionalInfo.totalPrice.toLocaleString()} د.ع</div>
            </div>
          </div>
        </div>

        {/* جدول الطلبات الجاهزة */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionTitle}>
              <Truck size={20} />
              <span>الطلبات الجاهزة للإرسال</span>
              {readyOrders.length > 30 && (
                <span style={{ ...styles.badge, backgroundColor: '#e8f5e9', color: '#27ae60' }}>
                  عرض {displayedReadyOrders.length} من {readyOrders.length}
                </span>
              )}
            </div>
            {readyOrders.length > 0 && (
              <button
                onClick={sendAllReadyOrders}
                disabled={sendingOrders}
                style={{
                  ...styles.sendButton,
                  opacity: sendingOrders ? 0.6 : 1,
                  cursor: sendingOrders ? 'not-allowed' : 'pointer'
                }}
                onMouseEnter={e => !sendingOrders && (e.target.style.backgroundColor = '#219a52')}
                onMouseLeave={e => !sendingOrders && (e.target.style.backgroundColor = '#27ae60')}
              >
                {sendingOrders ? (
                  <>
                    <Loader size={16} style={{ animation: 'spin 1s linear infinite' }} />
                    جاري الإرسال...
                  </>
                ) : (
                  <>
                    <Send size={16} />
                    إرسال {Math.min(readyOrders.length, 30)} طلب
                  </>
                )}
              </button>
            )}
          </div>

          <div style={styles.scrollWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>رقم الوصل</th>
                  <th style={styles.th}>اسم المستلم</th>
                  <th style={styles.th}>رقم الهاتف</th>
                  <th style={styles.th}>المحافظة</th>
                  <th style={styles.th}>المنطقة</th>
                  <th style={styles.th}>أقرب نقطة دالة</th>
                  <th style={styles.th}>المادة</th>
                  <th style={styles.th}>السعر</th>
                  <th style={styles.th}>الملاحظات</th>
                </tr>
              </thead>
              <tbody>
                {displayedReadyOrders.length > 0 ? (
                  displayedReadyOrders.map((order, index) => (
                    <tr
                      key={order.id}
                      style={{ backgroundColor: index % 2 === 0 ? 'white' : '#fafbfc' }}
                    >
                      <td style={styles.td}><span style={{ fontSize: '19px', fontWeight: '700' }}>{order.receiptNumber}</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600' }}>{order.recipientName}</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600', direction: 'ltr' }}>{order.recipientPhone}</span></td>
                      <td style={styles.td}>{renderEditableField(order, 'governorate', order.governorate, 'ready')}</td>
                      <td style={
                        (!order.area || order.area === '' || order.area === 'أخرى') ?
                          styles.warningCell :
                          styles.td
                      }>
                        {renderEditableField(order, 'area', order.area, 'ready')}
                      </td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600' }}>{order.nearestPoint}</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600' }}>{order.item}</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '700' }}>{parseInt(order.price).toLocaleString()} د.ع</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600' }}>{order.notes || '-'}</span></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" style={styles.emptyState}>
                      <Package size={48} style={{ marginBottom: '16px' }} />
                      <div>لا توجد طلبات جاهزة للإرسال</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* جدول الطلبات التي بها أخطاء */}
        <div style={styles.section}>
          <div style={{ ...styles.sectionHeader, backgroundColor: '#ffebee' }}>
            <div style={styles.sectionTitle}>
              <AlertCircle size={20} color="#e57373" />
              <span>الطلبات التي تحتاج إلى مراجعة</span>
              {errorOrders.length > 30 && (
                <span style={{ ...styles.badge, backgroundColor: '#ffcdd2', color: '#d32f2f' }}>
                  عرض {displayedErrorOrders.length} من {errorOrders.length}
                </span>
              )}
            </div>
            {errorOrders.length > 0 && (
              <button
                onClick={sendAllErrorOrders}
                disabled={sendingOrders}
                style={{
                  ...styles.sendButton,
                  backgroundColor: sendingOrders ? '#95a5a6' : '#e67e22',
                  opacity: sendingOrders ? 0.6 : 1,
                  cursor: sendingOrders ? 'not-allowed' : 'pointer'
                }}
                onMouseEnter={e => !sendingOrders && (e.target.style.backgroundColor = '#d35400')}
                onMouseLeave={e => !sendingOrders && (e.target.style.backgroundColor = '#e67e22')}
              >
                {sendingOrders ? (
                  <>
                    <Loader size={16} style={{ animation: 'spin 1s linear infinite' }} />
                    جاري الإرسال...
                  </>
                ) : (
                  <>
                    <Send size={16} />
                    إعادة إرسال {Math.min(errorOrders.length, 30)} طلب
                  </>
                )}
              </button>
            )}
          </div>

          <div style={styles.scrollWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>رقم الوصل</th>
                  <th style={styles.th}>اسم المستلم</th>
                  <th style={styles.th}>رقم الهاتف</th>
                  <th style={styles.th}>المحافظة</th>
                  <th style={styles.th}>المنطقة</th>
                  <th style={styles.th}>أقرب نقطة دالة</th>
                  <th style={styles.th}>المادة</th>
                  <th style={styles.th}>السعر</th>
                  <th style={styles.th}>الملاحظات</th>
                  <th style={styles.th}>الخطأ</th>
                </tr>
              </thead>
              <tbody>
                {displayedErrorOrders.length > 0 ? (
                  displayedErrorOrders.map((order, index) => (
                    <tr
                      key={order.id}
                      style={{ backgroundColor: index % 2 === 0 ? 'white' : '#fffbfb' }}
                    >
                      <td style={styles.td}><span style={{ fontSize: '19px', fontWeight: '700' }}>{order.receiptNumber}</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600' }}>{order.recipientName}</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600', direction: 'ltr' }}>{order.recipientPhone}</span></td>
                      <td style={styles.td}>{renderEditableField(order, 'governorate', order.governorate, 'error')}</td>
                      <td style={
                        (!order.area || order.area === '' || order.area === 'أخرى') ?
                          styles.warningCell :
                          styles.td
                      }>
                        {renderEditableField(order, 'area', order.area, 'error')}
                      </td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600' }}>{order.nearestPoint}</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600' }}>{order.item}</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '700' }}>{parseInt(order.price).toLocaleString()} د.ع</span></td>
                      <td style={styles.td}>{renderEditableField(order, 'notes', order.notes, 'error')}</td>
                      <td style={styles.td}>{renderEditableField(order, 'remark', order.remark, 'error')}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" style={styles.emptyState}>
                      <AlertCircle size={48} style={{ marginBottom: '16px' }} />
                      <div>لا توجد طلبات تحتاج مراجعة</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* جدول الطلبات المرسلة */}
        <div style={styles.section}>
          <div style={{ ...styles.sectionHeader, backgroundColor: '#e8eaf6' }}>
            <div style={styles.sectionTitle}>
              <CheckCircle size={20} color="#5c6bc0" />
              <span>الطلبات التي تم إرسالها</span>
              {sentOrders.length > 30 && (
                <span style={{ ...styles.badge, backgroundColor: '#c5cae9', color: '#3949ab' }}>
                  عرض {displayedSentOrders.length} من {sentOrders.length}
                </span>
              )}
            </div>
          </div>

          <div style={styles.scrollWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>رقم الوصل</th>
                  <th style={styles.th}>رقم الطلب لدى شركة التوصيل</th>
                  <th style={styles.th}>اسم المستلم</th>
                  <th style={styles.th}>رقم الهاتف</th>
                  <th style={styles.th}>المحافظة</th>
                  <th style={styles.th}>المنطقة</th>
                  <th style={styles.th}>أقرب نقطة دالة</th>
                  <th style={styles.th}>المادة</th>
                  <th style={styles.th}>السعر</th>
                  <th style={styles.th}>الملاحظات</th>
                </tr>
              </thead>
              <tbody>
                {displayedSentOrders.length > 0 ? (
                  displayedSentOrders.map((order, index) => (
                    <tr
                      key={order.id}
                      style={{ backgroundColor: index % 2 === 0 ? 'white' : '#fafaff' }}
                    >
                      <td style={styles.td}><span style={{ fontSize: '19px', fontWeight: '700' }}>{order.receiptNumber}</span></td>
                      <td style={{ ...styles.td, color: '#3498db', fontWeight: '700', fontSize: '19px' }}>{order.refId || '-'}</td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600' }}>{order.recipientName}</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600', direction: 'ltr' }}>{order.recipientPhone}</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600' }}>{order.governorate}</span></td>
                      <td style={
                        (!order.area || order.area === '' || order.area === 'أخرى') ?
                          styles.warningCell :
                          styles.td
                      }>
                        {(!order.area || order.area === '' || order.area === 'أخرى') ? (
                          <span style={styles.warningText}>
                            <AlertCircle size={20} />
                            {order.area || 'غير محدد'}
                          </span>
                        ) : (
                          <span style={{ fontSize: '18px', fontWeight: '600' }}>{order.area}</span>
                        )}
                      </td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600' }}>{order.nearestPoint}</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600' }}>{order.item}</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '700' }}>{parseInt(order.price).toLocaleString()} د.ع</span></td>
                      <td style={styles.td}><span style={{ fontSize: '18px', fontWeight: '600' }}>{order.notes || '-'}</span></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" style={styles.emptyState}>
                      <CheckCircle size={48} style={{ marginBottom: '16px' }} />
                      <div>لا توجد طلبات مرسلة</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        * {
          box-sizing: border-box;
        }
        
        /* إزالة الحد الأيمن من آخر خلية في كل صف */
        td:last-child, th:last-child {
          border-right: none !important;
        }
        
        /* إضافة حدود واضحة للجدول */
        table {
          border: 1px solid #e1e8ed;
          border-radius: 8px;
          overflow: hidden;
        }
        
        tbody tr:hover {
          background-color: #f5f7fa !important;
        }
        
        ::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
        
        ::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 4px;
        }
        
        ::-webkit-scrollbar-thumb {
          background: #bdc3c7;
          border-radius: 4px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
          background: #95a5a6;
        }
      `}</style>
    </div>
  );
};

export default OrdersManagementPage;